import React, { useState, useEffect, useCallback } from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight'
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft'
import { Stack } from '@chakra-ui/core'

const EmblaCarousel = ({ accentColour, arrowColour, progressIndicatorStyle, children }) => {
    const [emblaRef, emblaApi] = useEmblaCarousel({
        breakpoints: {
            '(min-width: 768px)': {
                align: 'start',
            },
        },
        skipSnaps: false,
    })

    const [prevBtnDisabled, setPrevBtnDisabled] = useState(true)
    const [nextBtnDisabled, setNextBtnDisabled] = useState(true)
    const [selectedIndex, setSelectedIndex] = useState(0)
    const [scrollSnaps, setScrollSnaps] = useState([])

    const scrollPrev = useCallback(() => emblaApi && emblaApi.scrollPrev(), [emblaApi])
    const scrollNext = useCallback(() => emblaApi && emblaApi.scrollNext(), [emblaApi])
    const scrollTo = useCallback(index => emblaApi && emblaApi.scrollTo(index), [emblaApi])

    const onInit = useCallback(emblaApi => {
        setScrollSnaps(emblaApi.scrollSnapList())
    }, [])

    const onSelect = useCallback(emblaApi => {
        setSelectedIndex(emblaApi.selectedScrollSnap())
        setPrevBtnDisabled(!emblaApi.canScrollPrev())
        setNextBtnDisabled(!emblaApi.canScrollNext())
    }, [])

    useEffect(() => {
        if (!emblaApi) return

        onInit(emblaApi)
        onSelect(emblaApi)
        emblaApi.on('reInit', onInit)
        emblaApi.on('reInit', onSelect)
        emblaApi.on('select', onSelect)
    }, [emblaApi, onInit, onSelect])

    return (
        <Stack paddingX={'20px'}>
            <Stack position={'relative'} width={'100%'} overflow={'hidden'} ref={emblaRef}>
                <Stack isInline gridColumnGap={'30px'}>
                    {children}
                </Stack>
                <Stack
                    role="button"
                    onClick={scrollNext}
                    style={{ backgroundColor: accentColour }}
                    width={'50px'}
                    height={'50px'}
                    borderRadius={'9999px'}
                    cursor={'pointer'}
                    position={'absolute'}
                    top={'50%'}
                    right={'0'}
                    transform={'translateY(calc(calc(50% + 60px) * -1))'}
                    alignItems={'center'}
                    isInline
                    justifyContent={'center'}
                    display={nextBtnDisabled ? 'none' : { base: 'none', md: 'flex' }}
                >
                    <FontAwesomeIcon
                        icon={faChevronRight}
                        style={{
                            color: arrowColour,
                            fontSize: '24px',
                        }}
                    />
                </Stack>
                <Stack
                    role="button"
                    onClick={scrollPrev}
                    style={{ backgroundColor: accentColour }}
                    width={'50px'}
                    height={'50px'}
                    borderRadius={'9999px'}
                    cursor={'pointer'}
                    position={'absolute'}
                    top={'50%'}
                    left={'0'}
                    transform={'translateY(calc(calc(50% + 60px) * -1))'}
                    isInline
                    alignItems={'center'}
                    justifyContent={'center'}
                    display={prevBtnDisabled ? 'none' : { base: 'none', md: 'flex' }}
                >
                    <FontAwesomeIcon
                        icon={faChevronLeft}
                        style={{
                            color: arrowColour,
                            fontSize: '24px',
                        }}
                    />
                </Stack>

                {/* {progressIndicatorStyle === 'bar' && (
                    <Stack
                        isInline
                        alignItems={'center'}
                        justifyContent={'center'}
                        marginTop={'30px'}
                    >
                        <Stack width={`100%`} height={`5px`} borderBottom={`1px solid #D8D8D8`}>
                            <Stack
                                style={{
                                    width: `${(selectedIndex + 1) * (100 / scrollSnaps.length)}%`,
                                    backgroundColor: accentColour,
                                }}
                                height={`100%`}
                                transition={`width 0.3s ease-in-out`}
                            />
                        </Stack>
                    </Stack>
                )} */}

                {progressIndicatorStyle === 'dots' && (
                    <Stack
                        isInline
                        alignItems={'center'}
                        justifyContent={'center'}
                        gridColumnGap={'0.5rem'}
                        marginTop={{
                            base: '30px',
                            md: '60px',
                        }}
                    >
                        {scrollSnaps.map((_, index) => (
                            <Stack
                                key={index}
                                onClick={() => scrollTo(index)}
                                style={{
                                    backgroundColor:
                                        index === selectedIndex ? accentColour : '#D8D8D8',
                                }}
                                width={'15px'}
                                height={'15px'}
                                borderRadius={'9999px'}
                                cursor={'pointer'}
                            />
                        ))}
                    </Stack>
                )}
            </Stack>
        </Stack>
    )
}

export default EmblaCarousel
